import React from "react";
import { FormattedMessage } from "react-intl";
import "./banner.scss";
import { ReactComponent as Apple } from "../../../../assets/Home/apple.svg";
import { ReactComponent as Google } from "../../../../assets/Home/google.svg";
import { Link } from "react-router-dom";
const Banner = () => {
  return (
    <div className="mobile-banner">
      <div className="bg"></div>
      <div className="text">
        <h1 className="mid-title">
          <FormattedMessage
            id="mobile-banner-title"
            defaultMessage="AdGate mobile app"
          />
        </h1>
        <p className="def-text">
          <FormattedMessage
            id="mobile-banner-title"
            defaultMessage="Mobile & Free for advertisers, publishers and agencies."
          />
        </p>
        <div className="btns">
          <Link to="/login">
            <Apple />
            <div className="text1">
              <small>
                <FormattedMessage
                  id="apple-small"
                  defaultMessage="Download on the"
                />
              </small>
              <h3>AppStore</h3>
            </div>
          </Link>

          <Link to="/login">
            <Google />
            <div className="text1">
              <small>
                <FormattedMessage
                  id="google-small"
                  defaultMessage="GET IT ON"
                />
              </small>
              <h3>PlayStore</h3>
            </div>
          </Link>
        </div>{" "}
      </div>
    </div>
  );
};

export default Banner;
